import React from 'react';
import Image from 'next/image';
import { formatDate } from '@/libs/blog/formatDate';

const BlogAuthor = ({ article }) => {
  const handleTwitterShare = () => {
    const endURL = `https://twitter.com/intent/tweet?url=https://medical.chat-data.com/blog/${
      article.slug
    }&text=${article.title}&hashtags=${article.hashtags.join(',')}`;

    const width = 500;
    const height = 600;
    const left = window.screen.width / 2 - width / 2;
    const top = window.screen.height / 2 - height / 2;
    const features = `width=${width},height=${height},left=${left},top=${top},resizable=yes`;
    window.open(endURL, '_blank', features);
  };
  const handleLinkedinShare = () => {
    const endURL = `https://www.linkedin.com/sharing/share-offsite/?url=https://medical.chat-data.com/blog/${article.slug}&mini=true&title=${article.title}`;

    const width = 500;
    const height = 600;
    const left = window.screen.width / 2 - width / 2;
    const top = window.screen.height / 2 - height / 2;
    const features = `width=${width},height=${height},left=${left},top=${top},resizable=yes`;
    window.open(endURL, '_blank', features);
  };
  const handleFacebookShare = () => {
    const authUrl = `https://www.facebook.com/sharer/sharer.php?u=https://medical.chat-data.com/blog/${article.slug}&quote=${article.title}`;

    const width = 500;
    const height = 600;
    const left = window.screen.width / 2 - width / 2;
    const top = window.screen.height / 2 - height / 2;
    const features = `width=${width},height=${height},left=${left},top=${top},resizable=yes`;
    window.open(authUrl, '_blank', features);
  };
  return (
    <div className="flex flex-row items-center justify-between mt-4 lg:mt-8">
      <div className="flex flex-col items-start gap-2 md:flex-row md:items-center">
        <Image
          alt={article.author}
          loading="lazy"
          width={32}
          height={32}
          decoding="async"
          className="rounded-full"
          src={article.avatar}
          style={{ color: 'transparent' }}
        />
        <div className="flex flex-col gap-1">
          <div className="flex flex-col items-start gap-2 text-sm text-zinc-900 md:flex-row md:items-center md:gap-1">
            <p className="font-medium text-zinc-900">{article.author}</p> on{' '}
            {formatDate(article.date)}
          </div>
          <p className="text-xs text-zinc-500">{article.minsToRead} min read</p>
        </div>
      </div>
      <div className="flex flex-row items-center gap-1">
        <button
          onClick={handleTwitterShare}
          aria-label="twitter"
          style={{
            backgroundColor: 'transparent',
            border: 'none',
            padding: '0px',
            font: 'inherit',
            color: 'inherit',
            cursor: 'pointer',
            outline: 'none',
          }}
        >
          <svg
            viewBox="0 0 24 24"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            width="35"
            height="35"
            className="rounded-md p-1.5 text-zinc-500 transition-colors duration-300 ease-in-out hover:bg-zinc-200 hover:text-zinc-900 active:ring-1"
          >
            <g>
              <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"></path>
            </g>
          </svg>
        </button>
        <button
          onClick={handleLinkedinShare}
          aria-label="linkedin"
          style={{
            backgroundColor: 'transparent',
            border: 'none',
            padding: '0px',
            font: 'inherit',
            color: 'inherit',
            cursor: 'pointer',
            outline: 'none',
          }}
        >
          <svg
            width="35"
            height="35"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="rounded-md p-1.5 text-zinc-500 transition-colors duration-300 ease-in-out hover:bg-zinc-200 hover:text-[#0C65C2] active:ring-1"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"
              fill="currentColor"
            ></path>
          </svg>
        </button>
        <button
          onClick={handleFacebookShare}
          aria-label="facebook"
          style={{
            backgroundColor: 'transparent',
            border: 'none',
            padding: '0px',
            font: 'inherit',
            color: 'inherit',
            cursor: 'pointer',
            outline: 'none',
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 36 36"
            fill="currentColor"
            height="35"
            width="35"
            className="rounded-md p-1.5 text-zinc-500 transition-colors duration-300 ease-in-out hover:bg-zinc-200 hover:text-[#0866FF] active:ring-1"
          >
            <path d="M20.181 35.87C29.094 34.791 36 27.202 36 18c0-9.941-8.059-18-18-18S0 8.059 0 18c0 8.442 5.811 15.526 13.652 17.471L14 34h5.5l.681 1.87Z"></path>
            <path
              fill="white"
              d="M13.651 35.471v-11.97H9.936V18h3.715v-2.37c0-6.127 2.772-8.964 8.784-8.964 1.138 0 3.103.223 3.91.446v4.983c-.425-.043-1.167-.065-2.081-.065-2.952 0-4.09 1.116-4.09 4.025V18h5.883l-1.008 5.5h-4.867v12.37a18.183 18.183 0 0 1-6.53-.399Z"
            ></path>
          </svg>
        </button>
      </div>
    </div>
  );
};

export default BlogAuthor;
